import { Button, Checkbox, Form, Input, Row } from 'antd'
import React from "react"
import { useTranslation } from "react-i18next"
import { useDispatch } from 'react-redux'
import { RouteChildrenProps } from "react-router"
import { Link } from "react-router-dom"
import { VALIDATION_MESSAGE_CONFIG } from "../../../../constants/constants"
import { LOCAL_STORAGE_KEY } from '../../../../constants/local'
import { ROUTE_PATHS } from "../../../../constants/url-config"
import { LoginReq } from "../../../../models/auth/sign-in"
import { setIsLogined } from '../../../../redux/actions/user.action'
import { AuthService } from "../../../../services/auth.service"
import "./sign-in.scss"
import LanguagePicker from '../../../../lang/shared/LanguagePicker'

interface Props extends RouteChildrenProps { }

export default function SignIn(props: Props) {
	const dispatch = useDispatch();
	const { t } = useTranslation();

	const handleSubmit = async (values: LoginReq) => {
		if (values.is_remember) {
			localStorage.setItem(LOCAL_STORAGE_KEY.REMEMBER_ME, "true");
		}

		const res = await AuthService.loginAsync(values);
		AuthService.setLoginData(res.data);
		dispatch(setIsLogined(true));
		const state: any = props.location.state;
		if (state && state.nextPathname) {
			props.history.push(state.nextPathname);
		} else {
			props.history.push(ROUTE_PATHS.Home);
		}
	}

	return (

		<div className="sign-in-form">
			<LanguagePicker />
			<div className='header'>
				<p className='big-title'>
					{t('Login.title')}
				</p>
				<p className='description-text'>
					{t('Login.welcome')}
				</p>
			</div>
			<Form
				name='signin'
				layout="vertical"
				onFinish={handleSubmit}
				validateMessages={VALIDATION_MESSAGE_CONFIG}
			>
				<Form.Item
					label={t('Login.email')}
					name='username'
					rules={[
						{ required: true }
						// { type: 'email', message: t('Login.emailInvalid') },
					]}
				>
					<Input />
				</Form.Item>

				<Row className='forgot-div'>
					<Link tabIndex={-1} to={ROUTE_PATHS.ForgotPassword} className='forgot-link'>
						{t('Login.forgotYourPassword')}
					</Link>
				</Row>


				<Form.Item
					label={t('Login.password')}
					name='password'
					rules={[{ required: true }]}
				>
					<Input.Password
						iconRender={visible => (visible ? t('Global.hide') : t('Global.show'))}
					/>
				</Form.Item>

				<Form.Item name='is_remember' valuePropName='checked'>
					<Checkbox>{t('Login.rememberMe')}</Checkbox>
				</Form.Item>

				<Form.Item >
					<Button htmlType='submit' type="primary" shape="round">
						{t('Login.continue')}
					</Button>
				</Form.Item>
			</Form>
		</div>

	)
}
